<template>
  <div class="pageNav">
    <router-link :to="{name: 'main', params: {id: setting.main.page, ln: setLang}}" class="home">
      <img src="~@/assets/img/ico_hotel.png" alt="" />
      <span>{{locale.backtohotel}}</span>
    </router-link>
    <SetLanguage
      :setting="setting"
      :lang="lang" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SetLanguage from '@/components/Util/SetLanguage.vue'

export default {
  props: [
    'locale',
    'lang'
  ],
  components: {
    SetLanguage
  },
  computed: {
    ...mapGetters({
      setting: 'common/getSetting'
    }),
    ln () {
      return this.$route.params.ln
    },
    setLang: {
      get () {
        return this.ln
      },
      set (ln) {
        this.$store.dispatch('common/setLang', ln)
        this.$store.commit('system/setLocale', ln)
      }
    }
  }
}
</script>

<style lang="scss">
  .pageNav {
    position: relative;
    height: 38px;
    border-bottom: 2px solid $color-red;
    .home {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      margin-right: auto;
      height: 100%;
      padding: 5px 15px;
      align-items: center;
      img {
        height: 26px;
        margin-right: 5px;
      }
    }
    .btnCountry {
      top: 5px;
    }
    .countryList {
      position: absolute;
      top: 36px;
      max-height: none;
    }
  }
</style>
